import { useEffect, useState, useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getDateTime, SessionKeys } from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import CONFIG from "../../../utils/config";
import {
  getAnyTotalReport,
  getOnboardingCompletionReport,
  getAnyTotalReportClear,
  getProfileCompletionReport,
  getProfileCompletionReportClear,
  getCoeRea,
  getCoeReaResClear,
  getCoeOffices,
  getCoeOfficesResClear,
  getCoeManagers,
  getCoeManagersResClear,
  getCoeTrendCurve,
  getCoeTrendCurveResClear,
  usageReport,
  getSavedFilterDataResponseClearById,
  getSavedFilterDataById,
  usageReportClear,
} from "../../../redux/reports/actions";
import _ from "lodash";
import PieChartComponent from "../ReportsComponents/PieChartComponent";
import ReportTableOnboard from "../ReportsComponents/ReportTableOnboard";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ManagerReportSecCoe from "../ReportsComponents/ManagerReportSecCoe";
import OfficeSectionCoe from "../ReportsComponents/OfficeSectionCoe";
import Loader from "../../Loader/Loader";
import CompletionTrendGraph from "../ReportsComponents/CompletionTrendGraph";
import { Spinner } from "react-bootstrap";
import ReportTableCoe from "../ReportsComponents/ReportTableCoe";
import AlertModalReports from "../ReportsComponents/alertModalReports";
import ReportHeaderComponent from "../layout/ReportHeaderComponent";
import ReportExportButtonComponent from "../layout/ReportExportButtonComponent";
import ReportFiltersComponent from "../layout/ReportFiltersComponent";
import DonutTrendChartComponent from "../layout/DonutTrendChartComponent";
import moment from "moment";
import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";
import ReportTableSystemUsage from "../ReportsComponents/ReportTableSystemUsage";
import { isAndroid, isIOS } from "react-device-detect";
import ConfirmModal from "../../modal/ConfirmModal";
import { useTranslation } from "react-i18next";
import ReportTableAssessmentResponse from "../ReportsComponents/ReportTableAssessmentResponse";
import { act } from "@testing-library/react";
const AssessmentReportSection = (props) => {
  const { isMobile } = props;

  let location = useLocation();
  const { t } = useTranslation();
  console.log("state---", location.state?.selectedFilters); // Access the state

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const filterId = params.get("filters_id");
  const backbutton = params.get("backbutton");
  const authBroker = useSelector((state) => state.auth.authBroker);
  const authIframeBroker = useSelector((state) => state.auth.authIframeBroker);

  const [savedFiltersDataById, setSavedFiltersDataById] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fileName = "Assessment Response Report";
  const [confirmModal, setConfirmModal] = useState(false);
  const [crsCompltTrendValues, setCrsCompltTrendValues] = useState([]);
  const [filterYearData, setFilterYearData] = useState([]);

  const [isView, setIsView] = useState("table");
  const [type, setType] = useState("pie");
  const [canShow, setCanShow] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [imgLoader, setImgLoader] = useState(true);
  const [reaList, setReaList] = useState([]);
  const [limitStatus, setLimitStatus] = useState("");
  const [loadSpin, setLoadSpin] = useState(true);
  const FILTER_BY = [
    { id: 0, value: "Select" },
    { id: 1, value: "Progress" },
    // { id: 1, value: "Learning Points" },
    // { id: 3, value: "Learning Hours" },
  ];
  // console.log("Thhh", overAllDataRes?.payload?.payload?.stats);
  const [statusFilterData] = useState([
    "Completed",
    "In Progress",
    "NotStarted",
  ]);
  const [profileReports, setProfileReports] = useState([]);
  const [totalRea, setTotalRea] = useState([]);
  const [profileReportsFilter, setProfileReportsFilter] = useState([]);

  // const profileReportRes = useSelector((state) => state.report?.profileReport);
  const usageReportRes = useSelector((state) => state?.report?.usageReportRes);
  const d = new Date();
  let year = d.getFullYear();
  const [trendYear, setTrendYear] = useState(year);
  const anyTotalReportRes = useSelector(
    (state) => state.report?.anyTotalReport,
  );
  const coeReaSectRes = useSelector((state) => state.report?.coeReportRea);

  const coeOfficesSectRes = useSelector(
    (state) => state.report?.coeReportOffices,
  );
  const coeTrendCurveRes = useSelector((state) => state.report?.coeTrend);
  // const crsCompletionTrendRes = useSelector(
  //   (state) => state.report.complianceCompletionTrend
  // );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  const [counter, setCounter] = useState(1);
  const [officeCounter, setOfficeCounter] = useState(1);
  const [managerCounter, setManagerCounter] = useState(1);
  const [filterBy, setFilterBy] = useState(FILTER_BY[0].value);
  const [actualCoursesList, setActualCoursesList] = useState([]);
  const [totalCountRea, setTotalCountRea] = useState("");
  const [showModalMsg, setShowModalMsg] = useState(
    "Available Real Estate Agents limit reached!",
  );
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const userDetailIframe = useSelector((state) => state.user.userDetailIframe);
  const [userDetails, setUserDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isExpand, setIsExpand] = useState(false);

  const [selectedFilters, setSelectedFilters] = useState({
    dateRange: { start: "", end: "" },
    dojRange: { start: "", end: "" },
    selectedProviderList: [],
    selectedOfficeList: [],
    selectedManagerCoachList: [],
    check: false,
    selectedCourseList: [],
    selectedTeamMatesList: [],
    selectedBrokerageList: [],
    selectedRole: [],
    selectedAgentStatus: [1],
    clickedApply: false,
    selectedGroupsList: [],
  });
  const [showFilters, setShowFilters] = useState({
    groups: false,
    reportingPeriod: false,
    provider: false,
    offices: false,
    role: false,
    reportingTo: false,
    learningContentType: false,
    learningContent: true,
    agents: true,
    status: false,
    dojBrokerage: true,
    date_range: true,
    agentStatus: false,
    roleFilter: {
      manager: true,
      guest: true,
      all: true,
      instructor: false,
      SystemUsageReports: true,
      rea: true,
    },
  });
  const [reaIds, setReaIds] = useState([]);
  const [officeIds, setOfficeIds] = useState([]);
  const [actionPathsIds, setActionPathsIds] = useState([]);
  const [managerIds, setManagerIds] = useState([]);
  const [statusAPI, setStatusAPI] = useState([
    "completed",
    "in-progress",
    "not-started",
  ]);
  const [Role, setRole] = useState([]);
  const [dojRange, setdojRange] = useState({ start: "", end: "" });
  const [officeLabel, setOfficeLabel] = useState("");

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (
        !_.isEmpty(authBroker.payload?.user?.config) &&
        authBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      if (
        !_.isEmpty(authIframeBroker.payload?.user?.config) &&
        authIframeBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authIframeBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (authBroker.status === "success") {
        if (authBroker.payload && authBroker.payload?.user) {
          if (authBroker.payload?.user?.is_corporate) {
            setShowFilters({
              reportingPeriod: false,
              provider: false,
              offices: false,
              role: false,
              reportingTo: false,
              learningContentType: false,
              learningContent: true,
              agents: true,
              status: false,
              groups: false,
              dojBrokerage: true,
              date_range: true,
              brokerages: true,
              agentStatus: false,
              roleFilter: {
                manager: true,
                guest: true,
                all: true,
                instructor: false,
                SystemUsageReports: true,
                rea: true,
              },
            });
            setIsExpand(true);
          }
        }
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      if (authIframeBroker.payload && authIframeBroker.payload?.user) {
        if (authIframeBroker.payload?.user?.is_corporate) {
          setShowFilters({
            reportingPeriod: false,
            provider: false,
            offices: false,
            role: false,
            reportingTo: false,
            learningContentType: false,
            learningContent: true,
            agents: true,
            groups: false,
            status: false,
            dojBrokerage: true,
            date_range: true,
            brokerages: true,
            agentStatus: false,
            roleFilter: {
              manager: true,
              guest: true,
              all: true,
              instructor: false,
              SystemUsageReports: true,
              rea: true,
            },
          });
          setIsExpand(true);
        }
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    console.log("ss-- loc", savedFiltersDataById?.filter_content);
    if (!_.isEmpty(savedFiltersDataById?.filter_content)) {
      setIsLoading(true);

      let reaIds =
        savedFiltersDataById?.filter_content.selectedTeamMatesList.map(
          (obj) => {
            return obj.user_id;
          },
        );

      let officeIds =
        savedFiltersDataById?.filter_content.selectedOfficeList.map((obj) => {
          console.log("GET OFFICE IDS get", obj);
          return obj.office_id;
        });

      let assessIds =
        savedFiltersDataById?.filter_content.selectedCourseList.map((obj) => {
          console.log("GET apIds IDS get", obj);
          return obj.id;
        });

      let managerIds =
        savedFiltersDataById?.filter_content.selectedManagerCoachList.map(
          (obj) => {
            return obj.id;
          },
        );

      let userStatus = 4;
      if (_.isArray(savedFiltersDataById?.filter_content.selectedAgentStatus)) {
        if (
          savedFiltersDataById?.filter_content.selectedAgentStatus.includes(
            3,
          ) ||
          (savedFiltersDataById?.filter_content.selectedAgentStatus.includes(
            1,
          ) &&
            savedFiltersDataById?.filter_content.selectedAgentStatus.includes(
              2,
            ))
        ) {
          userStatus = 3;
        } else if (
          savedFiltersDataById?.filter_content.selectedAgentStatus.includes(1)
        ) {
          userStatus = 1;
        } else if (
          savedFiltersDataById?.filter_content.selectedAgentStatus.includes(2)
        ) {
          userStatus = 2;
        }
      }

      let startDate = "";
      let endDate = "";
      if (savedFiltersDataById?.filter_content?.dojRange) {
        if (savedFiltersDataById?.filter_content?.dojRange?.start) {
          startDate = moment(
            savedFiltersDataById?.filter_content?.dojRange?.start,
            "MM/DD/YYYY",
          )
            .startOf("day")
            .valueOf();
          startDate = Math.floor(startDate / 1000);
        }
        if (savedFiltersDataById?.filter_content?.dojRange?.end) {
          endDate = moment(
            savedFiltersDataById?.filter_content?.dojRange?.end,
            "MM/DD/YYYY",
          )
            .endOf("day")
            .valueOf();
          endDate = Math.floor(endDate / 1000);
        }
      }

      dispatch(
        usageReport({
          module: "getAssessmentResListReport",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            // rea_ids: reaIds,
            // office_ids: officeIds,
            // manager_ids: managerIds,
            // role: savedFiltersDataById?.filter_content.selectedRole,
            // search: "",
            // page: "",
            // page_size: "",
            // date_range: savedFiltersDataById?.filter_content?.dojRange,
            // user_status: userStatus,
            action_path_name: assessIds,
            brokerage: savedFiltersDataById.selectedBrokerageList,
            group_id: selectedFilters.selectedGroupsList.map((o) =>
              _.toNumber(o?.id),
            ),
            start_date: startDate,
            end_date: endDate,
            user_name: reaIds,
          },
        }),
      );
    }
  }, [savedFiltersDataById]);

  useEffect(() => {
    if (filterId) {
      getSavedFiltersDataByIdFunc();
    }
    return () => {
      dispatch(getSavedFilterDataResponseClearById());
    };
  }, [filterId]);

  const getSavedFiltersDataByIdFunc = () => {
    setIsLoading(true);
    dispatch(
      getSavedFilterDataById({
        module: "getSavedFiltersDataById",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: filterId,
        },
      }),
    );
  };

  const getSavedFiltersDataResponseById = useSelector(
    (state) => state.report.savedFilterDataById,
  );

  useEffect(() => {
    if (!_.isEmpty(getSavedFiltersDataResponseById)) {
      if (getSavedFiltersDataResponseById?.status === "success") {
        setSavedFiltersDataById(
          getSavedFiltersDataResponseById?.payload?.payload[0],
        );
      } else {
        setSavedFiltersDataById("");
      }
    }
  }, [getSavedFiltersDataResponseById]);

  useEffect(() => {
    // console.log("from--".fromDashboard);
    // if (fromDashboard) {
    // } else {
    console.log("ss-- dispatch", !filterId);
    if (
      (!filterId || selectedFilters?.clickedApply) &&
      (authBroker.payload?.user || authIframeBroker.payload?.user) &&
      !(
        authBroker.payload?.user?.is_corporate ||
        authIframeBroker.payload?.user?.is_corporate
      )
    ) {
      loadAllApi();
    }
    // }
  }, [dispatch]);

  useEffect(() => {
    if (isMobile) {
      if (!_.isEmpty(userDetailIframe?.payload?.payload)) {
        setUserDetails(userDetailIframe?.payload?.payload);
      }
    } else {
      if (!_.isEmpty(userDetailRes?.payload?.payload)) {
        setUserDetails(userDetailRes?.payload?.payload);
      }
    }
  }, [userDetailRes, userDetailIframe, isMobile]);

  useEffect(() => {
    console.log("selected filters1", selectedFilters);
  }, [selectedFilters]);
  useEffect(() => {
    console.log("GET OFFICE IDS - ", officeIds);
  }, [officeIds]);

  let PageSize = 20;

  useEffect(() => {
    console.log("selected filter", selectedFilters);
    if (authBroker?.payload?.user || authIframeBroker?.payload?.user) {
      if (
        authBroker.payload?.user?.is_corporate ||
        authIframeBroker.payload?.user?.is_corporate
      ) {
        if (selectedFilters.clickedApply) {
          if (selectedFilters?.selectedBrokerageList?.length == 0) {
            setIsLoading(false);
            setConfirmModal(true);
          } else {
            setCounter(1);
            setOfficeCounter(1);
            setManagerCounter(1);
            setOfficeIds(
              selectedFilters.selectedOfficeList.map((obj) => {
                console.log("GET OFFICE IDS get", obj);
                return obj.office_id;
              }),
            );

            setActionPathsIds(
              selectedFilters.selectedCourseList.map((obj) => {
                console.log("GET OFFICE IDS get", obj);
                return obj.id;
              }),
            );

            setReaIds(
              selectedFilters.selectedTeamMatesList.map((obj) => {
                return obj.user_id;
              }),
            );

            setManagerIds(
              selectedFilters.selectedManagerCoachList.map((obj) => {
                return obj.id;
              }),
            );

            setRole(selectedFilters.selectedRole);
            setStatusAPI(selectedFilters.selectedStatus);
            setdojRange(selectedFilters.dojRange);
            setIsLoading(true);
            getTableReport();
          }
        } else {
          setIsLoading(false);
          setUsageReports([]);
        }
      } else if (
        (!_.isEmpty(selectedFilters) && !filterId) ||
        selectedFilters?.clickedApply
      ) {
        setCounter(1);
        setOfficeCounter(1);
        setManagerCounter(1);
        setOfficeIds(
          selectedFilters.selectedOfficeList.map((obj) => {
            console.log("GET OFFICE IDS get", obj);
            return obj.office_id;
          }),
        );

        setActionPathsIds(
          selectedFilters.selectedCourseList.map((obj) => {
            console.log("GET OFFICE IDS get", obj);
            return obj.id;
          }),
        );

        setReaIds(
          selectedFilters.selectedTeamMatesList.map((obj) => {
            return obj.user_id;
          }),
        );

        setManagerIds(
          selectedFilters.selectedManagerCoachList.map((obj) => {
            return obj.id;
          }),
        );

        setRole(selectedFilters.selectedRole);
        setStatusAPI(selectedFilters.selectedStatus);
        setdojRange(selectedFilters.dojRange);
        setIsLoading(true);
      }
    }
  }, [selectedFilters, authBroker]);

  useEffect(() => {
    if (
      (!filterId || selectedFilters?.clickedApply) &&
      (authBroker.payload?.user || authIframeBroker.payload?.user) &&
      !(
        authBroker.payload?.user?.is_corporate ||
        authIframeBroker.payload?.user?.is_corporate
      )
    ) {
      loadAllApi();
    }
  }, [reaIds, officeIds, actionPathsIds, statusAPI, Role, selectedFilters]);

  function setCount(counter, setCounter) {
    return setCounter(counter + 1);
  }
  const [usageReports, setUsageReports] = useState([]);
  const [usageReportsFilter, setusageReportsFilter] = useState([]);

  const currentTableData = useMemo(() => {
    if (usageReports !== null) {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      setCanShow(true);
      return usageReports.slice(firstPageIndex, lastPageIndex);
    }
  }, [currentPage, usageReports]);

  useEffect(() => {
    if (!_.isEmpty(usageReportRes)) {
      if (usageReportRes?.status === "success") {
        setIsLoading(false);
        const usageReport = usageReportRes?.payload?.payload;
        setUsageReports(usageReport);
        setusageReportsFilter(usageReport);
        setCurrentPage(1);
      } else {
        setUsageReports([]);
        setIsLoading(false);
        setCanShow(false);
      }
      dispatch(usageReportClear());
    }
  }, [usageReportRes]);

  const loadAllApi = () => {
    // getREADATA();
    // getTrendData();
    getTableReport();
    // getOfficeData();
    // getManagerData();
    setReaList([]);
  };

  const getTableReport = () => {
    let userStatus = 4;
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (
        selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) &&
          selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3;
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1;
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2;
      }
    }

    console.log("dojRange: ", selectedFilters);
    let startDate = "";
    let endDate = "";
    if (selectedFilters?.dojRange) {
      if (selectedFilters?.dojRange.start) {
        startDate = moment(selectedFilters?.dojRange.start, "MM/DD/YYYY")
          .startOf("day")
          .valueOf();
        startDate = Math.floor(startDate / 1000);
      }
      if (selectedFilters?.dojRange.end) {
        endDate = moment(selectedFilters?.dojRange.end, "MM/DD/YYYY")
          .endOf("day")
          .valueOf();
        endDate = Math.floor(endDate / 1000);
      }
    }

    dispatch(
      usageReport({
        module: "getAssessmentResListReport",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          // rea_ids: selectedFilters.selectedTeamMatesList.map(
          //   (obj) => obj.user_id
          // ),
          // office_ids: selectedFilters.selectedOfficeList.map(
          //   (obj) => obj.office_id
          // ),
          // manager_ids: selectedFilters.selectedManagerCoachList.map(
          //   (obj) => obj.id
          // ),
          // role: savedFiltersDataById?.filter_content?.selectedRole,
          // search: "",
          // page: "",
          // page_size: "",
          // date_range: dojRange,
          // user_status: userStatus,
          action_path_name: selectedFilters.selectedCourseList.map(
            (obj) => obj.id,
          ),
          brokerage: selectedFilters?.selectedBrokerageList,
          group_id: selectedFilters.selectedGroupsList.map((o) =>
            _.toNumber(o?.id),
          ),
          start_date: startDate,
          end_date: endDate,
          user_name: selectedFilters.selectedTeamMatesList.map(
            (obj) => obj.user_id,
          ),
        },
      }),
    );
  };

  function formatDate(inputDate) {
    let formattedDate = "-";
    if (inputDate) {
      formattedDate = moment(inputDate, "MM/DD/YYYY").format("MMM DD, YYYY");
    }
    return formattedDate;
  }

  const ExportToExcel = () => {
    const data = _.cloneDeep(usageReports);
    console.log("data for excel", data);
    // for (let item of data) {
    //     item.status =
    //         item?.status === "Active"
    //             ? "Active"
    //             : item?.status === "Not Verify"
    //                 ? "Not Verify"
    //                 : "Expired";
    // }

    let maxCount = 0;
    let filterData = data;
    filterData.map((item) => {
      if (item?.assesment_responses?.length > maxCount) {
        maxCount = item?.assesment_responses?.length;
      }
    });

    let tempArr = [];
    for (let index = 0; index < data.length; index++) {
      const element = data[index];

      let obj = {};

      obj["First Name"] = element.first_name;
      obj["Last Name"] = element.last_name;
      obj["Email"] = element.user_email;
      // obj["Group Name"] = Array.isArray(element?.group_name)
      //   ? element?.group_name?.join(", ")
      //   : element?.group_name;
      obj["Assessment Date & Time (ET)"] = moment(
        element?.assessment_date,
        "YYYY-MM-DD HH:mm:ss",
      ).format("DD/MM/YYYY hh:mm A");
      obj["Assessment Name"] = element.ap_name;
      for (let item2 = 0; item2 < maxCount; item2++) {
        const element1 = element?.assesment_responses[item2];
        obj["Question " + (item2 + 1)] = element1?.response
          ? element1?.ques + "\n Response: " + element1?.response
          : "-";
      }

      tempArr.push(obj);
    }

    // console.log('data:', data)
    // exportFromJSON({ data, fileName, exportType })

    //For mobile
    let tempObj = {
      method: "AssessmentResponsesReport",
      report: tempArr,
    };
    if (window.callbackHandler != undefined) {
      window.callbackHandler.postMessage(JSON.stringify(tempObj));
    } else if (window.webkit != undefined) {
      if (window.webkit.messageHandlers.callbackHandler != undefined) {
        window.webkit.messageHandlers.callbackHandler.postMessage(
          JSON.stringify(tempObj),
        );
      }
    }

    const worksheet = XLSX.utils.json_to_sheet(tempArr);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, fileName + ".xlsx");
  };

  const searchTable = (searchVal) => {
    console.log("searched value", searchVal);
    let list = _.cloneDeep(usageReportsFilter);
    console.log(list, searchVal);
    if (searchVal === "") {
      setUsageReports(list);
      return;
    }

    let filterBySearch = [];
    for (const item of list) {
      if (
        item?.first_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.last_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.user_email?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.ap_name?.toLowerCase().includes(searchVal.toLowerCase())
      ) {
        filterBySearch.push(item);
      }
    }
    console.log("filterBySearch: ", filterBySearch);

    setUsageReports(filterBySearch);
  };

  const handleClick = () => {
    window.scrollTo(0, 450);
  };

  return (
    <>
      <Loader start={isLoading} />
      <section className="reports-header mt-2rem">
        <div className="container-pwc">
          <div className="row">
            <div className="col-md-12 text-start mb-4">
              {JSON.parse(backbutton) ? (
                ""
              ) : (
                <button
                  type="button"
                  id="backbtnreport"
                  className="btn btn-primary-complete bckbtn m-0"
                  onClick={() => {
                    dispatch(getSavedFilterDataResponseClearById());
                    let obj = { message: "backButton" };
                    if (isMobile) {
                      window.parent.postMessage(
                        JSON.stringify(obj),
                        CONFIG.API_URL_BROKER_ADMIN,
                      );
                      window.parent.postMessage(
                        JSON.stringify(obj),
                        CONFIG.API_URL,
                      );
                    } else {
                      navigate(-1);
                    }
                    if (isAndroid || isIOS) {
                      try {
                        if (window.callbackHandler != undefined) {
                          window.callbackHandler.postMessage("backButton");
                        }
                        if (window.webkit != undefined) {
                          if (
                            window.webkit.messageHandlers.callbackHandler !=
                            undefined
                          ) {
                            window.webkit.messageHandlers.callbackHandler.postMessage(
                              "backButton",
                            );
                          }
                        }
                      } catch (err) {
                        console.log("error in sending message");
                      }
                    }
                  }}
                >
                  {t("back")}
                </button>
              )}
            </div>
            <div className="col-md-12">
              <div className="reports-head-main">{t("Reports")}</div>
            </div>

            <div className="col-md-12 d-flex justify-content-between dropbox-section">
              <ReportHeaderComponent
                title={t("Assessment Response Report")}
                isFilterExpand={isExpand}
                setIsFilterExpand={setIsExpand}
                exportReport={ExportToExcel}
              />
              <ReportExportButtonComponent exportReport={ExportToExcel} />
            </div>
            <div className="col-md-12">
              {isExpand && (
                <ReportFiltersComponent
                  setSelectedFilters={setSelectedFilters}
                  selectedFiltersFromDashboard={
                    savedFiltersDataById?.filter_content
                      ? savedFiltersDataById?.filter_content
                      : ""
                  }
                  setIsExpand={setIsExpand}
                  handleClick={handleClick}
                  isMobile={isMobile}
                  showFilters={showFilters}
                  hideOverDueStatus={true}
                  reportType={"system_usage_report"}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      <div id="myOnboard" class="center_line"></div>
      <div className="system-usage-table">
        <ReportTableAssessmentResponse
          setSearchInput={""}
          getFilteredData={[]}
          lpName={"Onboarding Name"}
          isView={isView}
          // statusFilterData={statusFilterData}
          setCanShow={setCanShow}
          profileReports={usageReports}
          currentTableData={currentTableData}
          type={type}
          message={t(
            (authBroker?.payload?.user?.is_corporate &&
              authBroker?.payload?.user?.is_corporate !== undefined) ||
              (authIframeBroker?.payload?.user?.is_corporate !== undefined &&
                authIframeBroker?.payload?.user?.is_corporate)
              ? "Assessment responses submitted by users will appear here. Please select a client from the filter above to view the responses."
              : "Assessment response submitted by users will appear here.",
          )}
          searchTable={searchTable}
        />
      </div>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={`Client is mandatory, please select first.`}
        //   ${
        //   officeLabel == "Office Name" ? "Office(s)" : officeLabel
        // }

        isConfirm={false}
        confirmId={""}
        confirmAction={""}
        isRightIcon={false}
        isMobile={isMobile}
      />
    </>
  );
};

export default AssessmentReportSection;
